import React, { useEffect } from "react";
import { auth } from "../firebase";

export default function BannedPage() {
  const reason = localStorage.getItem("banReason") || "No reason provided";

  useEffect(() => {
    auth.signOut().catch(console.error);
  }, []);

  return (
    <div style={{ textAlign: "center", padding: "2rem" }}>
      <h1>You are banned</h1>
      <p>Reason: {reason}</p>
    </div>
  );
}
